<template>
  <b-form-group label="Targets (Updates here are immediately executed)">
    <edit-project-one-target
      v-for="targetId in targetsKeys"
      :key="targetId"
      :target="targets[targetId]"
      :targetId="targetId"
      :projectId="projectId"
    />
    <b-button @click="addNewTarget">Add New Target</b-button>
  </b-form-group>
</template>
<script>
import EditProjectOneTarget from "./EditProjectOneTarget.vue";

export default {
  name: "EditProjectTargets",
  components: {
    EditProjectOneTarget,
  },
  methods: {
    addNewTarget() {
      console.log("Add New Target clicked");
    },
  },
  computed: {
    targetsKeys() {
      return this.targets ? Object.keys(this.targets) : [];
    },
  },
  props: ["targets", "projectId"],
};
</script>
<style scoped></style>
